import { useMemo } from 'react';
import { useLayout } from '../contexts/LayoutContext';
import { compactBox, createChartGeometry, desktopBox, type ChartGeometry } from '../utils/chart';

export function useChartGeometry(): ChartGeometry {
  const { compact } = useLayout();
  return useMemo(() => createChartGeometry(compact ? compactBox : desktopBox, compact), [compact]);
}
